export const REINSURANCE_DEPT = "reinsurance";

export const FEATURE = {
  TREATY: "treaty_management",
  BROKER: "broker_management",
  REINSURER: "reinsurer_management",
} as const;

export const PERMISSION = {
  // treaty
  VIEW_TREATIES: "view_treaties",
  CREATE_TREATY: "create_treaty",
  EDIT_TREATY: "edit_treaty",
  RENEW_TREATY: "renew_treaty",
  DEACTIVATE_TREATY: "deactivate_treaty",
  APPROVE_TREATY: "approve_treaty",
  // broker
  VIEW_BROKERS: "view_reinsurance_brokers",
  ADD_BROKER: "add_reinsurance_brokers",
  EDIT_BROKER: "edit_reinsurance_brokers",
  DEACTIVATE_BROKER: "deactivate_reinsurance_brokers",
  REACTIVATE_BROKER: "reactivate_reinsurance_brokers",
  // reinsurer
  VIEW_REINSURERS: "view_reinsurers",
  ADD_REINSURER: "add_reinsurer_profile",
  EDIT_REINSURER: "edit_reinsurer_profile",
  DEACTIVATE_REINSURER: "deactivate_reinsurer_profile",
  REACTIVATE_REINSURER: "reactivate_reinsurer_profile",
} as const;
